<template>
  <div class="category-index">
    <div class="index">
      <i class="far fa-arrow-down"></i>
      <p>Name:</p>
    </div>
    <div class="index">
      <i class="far fa-arrow-down"></i>
      <p>Number of Items:</p>
    </div>
    <div class="index">
      <i class="far fa-arrow-down"></i>
      <p>Date Modified:</p>
    </div>
    <div class="index">
      <i class="far fa-arrow-down"></i>
      <p>Created By:</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryIndex",
};
</script>

<style lang="scss" scoped>
.category-index div {
  flex: 1;
}
</style>
